import React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { DeveloperText, List } from './styles'
import images from '../../config/images.js'
import FlatButton from 'material-ui/FlatButton'

const Menu = () => (
  <div className="w-100 flex justify-between" >
    <List className="link white flex" style={{alignItems: 'center'}}>
      <li>
        <FormattedHTMLMessage id="footerMenu.about"/>
      </li>
    </List>
    <List className="link white" className>
      <li>
        <FlatButton
          label={'日本語/English'}
          backgroundColor="transparent"
          hoverColor="#1b8859"
          labelStyle={{color: '#FFFFFF'}}
          onClick={() => {
            let locale = localStorage.getItem('locale')
            if (locale == 'ja') {
              localStorage.setItem('locale', 'en')
            } else {
              localStorage.setItem('locale', 'ja')
            }
            window.location.reload()
          }}
          />
      </li>
    </List>
    <div className="flex justify-center items-center">
      <div style={{marginBottom:'17px'}}>
        <DeveloperText>
          <FormattedMessage id="footerMenu.developedBy"/>
        </DeveloperText>
        <span>
          <img src={images.anet} className="h-100" alt="anet"/>
        </span>
      </div>
    </div>
  </div>
)

export default Menu



// WEBPACK FOOTER //
// src/components/FooterMenu/FooterMenu.js